import React, { ReactNode } from "react";
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@mui/material";
import { IconChevronDown } from "@tabler/icons";

function Accordion({
  title,
  defaultExpanded = false,
  children
}: {
  title: string;
  defaultExpanded?: boolean
  children: ReactNode;
}) {
  return (
    <MuiAccordion defaultExpanded={defaultExpanded} className="border mb-2">
      <div className="border">
        <AccordionSummary
          expandIcon={<IconChevronDown />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h6">{title}</Typography>
        </AccordionSummary>
      </div>
      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
}

export default Accordion;
